import axios from '../../../axiosInstance';
import { IAuthenticateUserPayload } from '../types';

export const authenticateUser = (payload: IAuthenticateUserPayload) =>
  axios.post('/auth/signin', payload);
